import { render } from "./TypeWriter.vue?vue&type=template&id=9e763618&scoped=true"
const script = {}

import "./TypeWriter.vue?vue&type=style&index=0&id=9e763618&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\TvBerater\\FernseherBeraterUpdate05012026\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e763618"]])

export default __exports__